import React from "react";
import {
  TeamOutlined,
  BankOutlined,
  ApartmentOutlined,
  BookOutlined,
  UserOutlined,
  DollarCircleOutlined,
  UsergroupAddOutlined,
  PayCircleOutlined,
  CarryOutOutlined,
  CalendarOutlined,
  BarsOutlined,
  ContactsOutlined,
  MessageOutlined,
  SettingOutlined,
  UnlockOutlined,
  CheckCircleOutlined,
  ScheduleOutlined,
  CopyOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: "公司管理",
    key: "company",
    url: "/company",
    icon: <BankOutlined />,
  },
  {
    title: "部门管理",
    key: "department",
    url: "/department",
    icon: <ApartmentOutlined />,
  },
  {
    title: "员工管理",
    key: "employee",
    url: "/employee",
    icon: <TeamOutlined />,
  },
  {
    title: "用户管理",
    key: "user",
    url: "/user",
    icon: <UserOutlined />,
  },
  {
    title: "员工应聘",
    key: "companyApplication",
    url: "/companyApplication",
    icon: <UsergroupAddOutlined />,
  },

  {
    title: "薪资管理",
    key: "salary",
    url: "/admin",
    icon: <PayCircleOutlined />,
    children: [
      {
        title: "薪资列表",
        key: "salary",
        url: "/admin/salary",
        icon: <DollarCircleOutlined />,
      },
      // {
      //   title: "薪资分类",
      //   key: "salaryCategories",
      //   url: "/admin/salaryCategories",
      //   icon: <BarsOutlined />,
      // },
    ],
  },
  // 日报管理
  {
    title: "日报管理",
    key: "dailyReport",
    url: "/admin/dailyReports",
    icon: <CopyOutlined />,
  },

  {
    title: "消息管理",
    key: "messages",
    url: "/messages",
    icon: <MessageOutlined />,
  },
  {
    title: "通讯录管理",
    key: "contact",
    url: "/contact",
    icon: <ContactsOutlined />,
  },
  // 假期管理
  {
    title: "假期管理",
    key: "leave",
    icon: <CalendarOutlined />,
    url: "/admin",
    children: [
      {
        title: "假期类型",
        key: "leaveTypes",
        url: "/admin/leaveTypes",
        icon: <AppstoreOutlined />,
      },
      {
        title: "假期审批",
        key: "leaveApproval",
        url: "/admin/leaveApproval",
        icon: <CheckCircleOutlined />,
      },
    ],
  },
  {
    title: "考勤管理",
    key: "schedule",
    icon: <ScheduleOutlined />,
    url: "/schedule",
    children: [
      {
        title: "排班类型管理",
        key: "shiftTypeManage",
        url: "/schedule/shiftTypes",
        icon: <BarsOutlined />,
      },
      {
        title: "排班管理",
        key: "schedule",
        url: "/schedule/list",
        icon: <ScheduleOutlined />,
      },
      {
        title: "考勤组",
        key: "attendanceGroups",
        url: "/schedule/attendanceGroups",
        icon: <CarryOutOutlined />,
      },
      {
        title: "考勤规则",
        key: "attendanceRules",
        url: "/schedule/attendanceRules",
        icon: <CalendarOutlined />,
      },
      {
        title: "打卡记录",
        key: "attendanceRecords",
        url: "/schedule/attendanceRecords",
        icon: <ContactsOutlined />,
      },
      {
        title: "异常考勤审批",
        key: "attendanceConfirmations",
        url: "/schedule/attendanceConfirmations",
        icon: <CheckCircleOutlined />,
      },
    ],
  },
  {
    title: "系统管理",
    key: "admin",
    icon: <SettingOutlined />,
    url: "/admin",
    children: [
      // {
      //   title: "权限管理",
      //   key: "permissions",
      //   url: "/admin/permissions",
      //   icon: <UnlockOutlined />,
      // },
      {
        title: "角色管理",
        key: "roles",
        url: "/admin/roles",
      },
    ],
  },
  // {
  //   title: 'API 文档',
  //   key: 'docs',
  //   url: '/docs',
  //   icon: <BookOutlined />,
  // },
];
